import { createContext } from 'react'

const ImageVersioningContext = createContext({
  version: '',
  getUrlWithVersion: () => {},
  setImageVersion: (version) => {},
})

export default ImageVersioningContext
